import React from 'react'
import styled from 'styled-components'

import { useTranslation } from '@root/shared/localization'

import { InstantTradeWalletBalance } from './instant-trade-wallet-balance'

import type { PairModel } from '@root/entities/pair'
import type { TradeType } from '@root/entities/trade-type'

type Props = {
  swapDirection: TradeType.SwapDirection
  pair: PairModel
  children?: React.ReactNode
}

export const InstantTradeSwapHeading: React.FC<Props> = ({
  swapDirection,
  pair,
  children,
}) => {
  const { t } = useTranslation()

  return (
    <Root>
      <Label $swapDirection={swapDirection}>
        {t(swapDirection === 'buy' ? 'trading.buy' : 'trading.sell')}
      </Label>
      <ChildrenContainer>{children}</ChildrenContainer>
      <InstantTradeWalletBalance swapDirection={swapDirection} pair={pair} />
    </Root>
  )
}

const Root = styled.div`
  font-size: 12px;
  margin-bottom: 9px;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  place-content: center;
  align-items: center;
`

const Label = styled.h3<{ $swapDirection: TradeType.SwapDirection }>`
  color: ${({ $swapDirection }) =>
    $swapDirection === 'buy' ? 'var(--upAccent-9)' : 'var(--downAccent-9)'};

  font-size: 14px;
  font-weight: 600;
  line-height: 1;
`

const ChildrenContainer = styled.div`
  justify-self: center;
`
